(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/views/pages/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/views/pages/fractiongames-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.templates=_svs.vikinglotto.templates||{};
svs.vikinglotto.templates.fractiongames_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngFractiongamesRegion\" class=\"vikinglotto-fractiongames-wrapper\"></div>\n";
},"useData":true});
Handlebars.partials['svs-vikinglotto-fractiongames_page'] = svs.vikinglotto.templates.fractiongames_page;
})(svs, Handlebars);


 })(window);